import apis from "../../core/apis.js";

class PrivateBusRequestsResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.privateBusRequests).get(options);
  }

  get(id) {
    return this.$resource(apis.privateBusRequests + id).get();
  }

  search(search = "") {
    return this.$resource(apis.privateBusRequests).get({ search });
  }

  post(item) {
    return this.$resource(apis.privateBusRequests).save(item);
  }

  update(id, item) {
    return this.$resource(apis.privateBusRequests + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
  addCaptin(id, captainId) {
    return this.$resource(apis.privateBusRequests + id + "/accept").save(
      captainId
    );
  }
  reject(id) {
    return this.$resource(apis.privateBusRequests + id + "/reject").save();
  }
}

export default PrivateBusRequestsResource;



// WEBPACK FOOTER //
// ./src/resources/privateBusRequests/privateBusRequests.resource.js